import React from 'react';
import OnBoardingNext from './OnBoardingNext';
import OnBoardingSkip from './OnBoardingSkip';
import s from './onBoardingNextSkip.scss';

var OnBoardingNextSkip = function OnBoardingNextSkip(props) {
  var onNext = props.onNext,
      onSkip = props.onSkip,
      nextText = props.nextText,
      skipText = props.skipText,
      _props$bng = props.bng,
      bng = _props$bng === void 0 ? false : _props$bng;
  return /*#__PURE__*/React.createElement("div", {
    className: s.container
  }, /*#__PURE__*/React.createElement(OnBoardingNext, {
    onNext: onNext,
    nextText: nextText,
    bng: bng
  }), /*#__PURE__*/React.createElement(OnBoardingSkip, {
    onSkip: onSkip,
    skipText: skipText
  }));
};

export default OnBoardingNextSkip;